"use client";

import classNames from "classnames";
import type { SearchTab } from ".";

type SearchTabsClientProps = {
  tabs: SearchTab[];
  activeKey: string;
  onSelect: (key: string) => void;
  className?: string;
};

const SearchTabsClient = ({
  tabs,
  activeKey,
  onSelect,
  className,
}: SearchTabsClientProps) => {
  if (!tabs.length) return null;

  return (
    <div
      className={classNames(
        "flex gap-2 overflow-x-auto hide-scrollbar px-4 py-3",
        className,
      )}
      role="tablist"
    >
      {tabs.map((tab) => {
        const isActive = tab.key === activeKey;
        return (
          <button
            type="button"
            key={tab.key}
            role="tab"
            aria-selected={isActive}
            onClick={() => onSelect(tab.key)}
            className={classNames(
              "shrink-0 inline-flex items-center gap-2 px-3 py-2 rounded-sm font-bold whitespace-nowrap transition-colors text-sm",
              isActive
                ? "bg-sand-800 text-black-500"
                : "bg-sand-600 text-black-500 hover:bg-sand-700",
            )}
          >
            <span>{tab.label}</span>
            {typeof tab.count === "number" && tab.count > 0 && (
              <span className="text-xs font-normal text-gray-400">
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default SearchTabsClient;
